export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS';

export default {
  FETCH_NOTIFICATIONS,
  READ_NOTIFICATIONS,
};
